<template>
  <div class="flex flex-column flex-gap-1">
    <h2>
      {{
        t('parcelScheduling.selectedDateParam', {
          param: renderDateTime(userSelectedDate, {
            timeFormat: 'NONE',
          }),
        })
      }}
    </h2>
    <ShipmentSearchResultView
      v-model:columns="columns"
      v-model:selection="selectedShipments"
      :shipment-search-criteria="modelValue"
      :results="results"
      @page="emit('page', $event)"
      @sort="emit('sort', $event)"
      @refresh-no-cache="emit('refresh-search')"
    />
    <h2>{{ t('parcelScheduling.additionalDates') }}</h2>
    <ShipmentSearchResultView
      v-model:columns="columns"
      v-model:selection="selectedShipments"
      :shipment-search-criteria="modelValue"
      :results="fuzzyResults"
      @page="emit('page', $event)"
      @sort="emit('sort', $event)"
      @refresh-no-cache="emit('refresh-search')"
    />
  </div>
</template>

<script lang="ts" setup>
import { DateTime } from 'luxon';
import { PropType, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { renderDateTime } from '@rygen/rygen-ui/i18n';
import { ColumnSpecification, Loadable } from '@rygen/rygen-ui/model';

import {
  ShipmentSearchCriteria,
  ShipmentSearchData,
  ShipmentSearchResult,
} from '@/model';

import ShipmentSearchResultView from '@/components/shipment/ShipmentSearchResult.vue';
import { DataTablePageEvent, DataTableSortEvent } from 'primevue/datatable';

const modelValue = defineModel({
  type: ShipmentSearchCriteria,
  required: true,
});

const selectedShipments = defineModel('selectedShipments', {
  type: Array as PropType<ShipmentSearchData[]>,
  default: () => [],
});

const columns = defineModel('columns', {
  type: Array as PropType<ColumnSpecification[]>,
  default: () => [],
});

const props = defineProps({
  fuzzyResults: {
    type: Object as PropType<Loadable<ShipmentSearchResult>>,
    default: () => ({ loading: false }),
  },
  results: {
    type: Object as PropType<Loadable<ShipmentSearchResult>>,
    default: () => ({ loading: false }),
  },
  userSelectedDate: {
    type: Object as PropType<DateTime>,
    default: undefined,
  },
});

const { fuzzyResults, results, userSelectedDate } = toRefs(props);

const emit = defineEmits<{
  (event: 'page', payload: DataTablePageEvent): void;
  (event: 'sort', payload: DataTableSortEvent): void;
  (event: 'refresh-search'): void;
}>();

const { t } = useI18n();
</script>
